import React, { useEffect, useState } from "react"
import { Layout, Alert, Form, Row, Col, notification, Switch } from "antd"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

/* CUSTOM COMPONENT */
import LoginHeader from '../LoginHeader/LoginHeader';
import { SiteLayoutBackground, Left, Right, LoginBox, XContent, SignIn, TextBox, XButton, FormItem, SignUpDiv, SignUpLink, SocialButton } from "./SignUpStyle"
/* Actions */
import { FaceBookIcon, GoogleIcon } from "../CustomIcons";
import { BlankSpace } from "../Xcomponent";

const InstituteDetail = (props) => {

const [form] = Form.useForm();
const handleSubmit = (values) => {
    // props.saveData("instituteDetails",values)
    console.log(values)
    props.handleSubmit("instituteDetails",values)
}

return <>
   <Form layout="vertical" onFinish={handleSubmit}>
             <Row gutter={[20, 20]}>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                     <FormItem
                         label="Institute Name"
                         name="institute_name"
                         rules={[
                             { required: true, message: 'Please enter institute name' },
                         ]}
                     >
                         <TextBox
                             name="institute_name"
                             size="large"
                         />
                     </FormItem>
                 </Col>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                     <FormItem
                         label="Email ID"
                         name="institute_email"
                         rules={[
                             { type: 'email', message: 'Email id is not valid' },
                         ]}
                     >
                         <TextBox
                             name="institute_email"
                             size="large"
                         />
                     </FormItem>
                 </Col>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                     <FormItem
                         label="Address"
                         name="institute_address"
                         rules={[
                             { required: true, message: 'Please enter institute address' },
                         ]}
                     >
                         <TextBox
                             name="institute_address"
                             size="large"
                         />
                     </FormItem>
                 </Col>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                     <FormItem
                         label="FMF Code"
                         name="fmf_code"
                         rules={[
                         ]}
                     >
                         <TextBox
                             name="fmf_code"
                             size="large"
                         />
                     </FormItem>
                 </Col>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Registration No."
                        name="registration_number"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="registration_number"
                          size="large"
                        />
                      </FormItem>
                    </Col>
             </Row>
             <Row gutter={[20, 20]}>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                     <FormItem>
                         <XButton
                             onClick={props.handlePrevious}
                             type="primary"
                             size="large"
                             block >Previous</XButton>
                     </FormItem>
                 </Col>
                 <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                     <FormItem>
                         <XButton htmlType="submit" type="primary"
                             size="large"
                             block >Submit</XButton>
                     </FormItem>
                 </Col>
             </Row>
             <BlankSpace />
             <BlankSpace />
         </Form>
    </>
}

export default InstituteDetail